export default {
  'search.SearchBar.label': 'Search',
  'search.SearchModal.errorScreen.helpText': 'You might want to check your network connection.',
  'search.SearchModal.errorScreen.titleText': 'Unable to fetch results',
  'search.SearchModal.footer.closeKeyAriaLabel': 'Escape key',
  'search.SearchModal.footer.closeText': 'to close',
  'search.SearchModal.footer.navigateDownKeyAriaLabel': 'Arrow down',
  'search.SearchModal.footer.navigateText': 'to navigate',
  'search.SearchModal.footer.navigateUpKeyAriaLabel': 'Arrow up',
  'search.SearchModal.footer.searchByText': 'Search by',
  'search.SearchModal.footer.selectKeyAriaLabel': 'Enter key',
  'search.SearchModal.footer.selectText': 'to select',
  'search.SearchModal.noResultsScreen.noResultsText': 'No results for',
  'search.SearchModal.noResultsScreen.reportMissingResultsLinkText': 'Let us know.',
  'search.SearchModal.noResultsScreen.reportMissingResultsText':
    'Believe this query should return results?',
  'search.SearchModal.noResultsScreen.suggestedQueryText': 'Try searching for',
  'search.SearchModal.placeholder': 'Search docs',
  'search.SearchModal.searchBox.cancelButtonText': 'Cancel',
  'search.SearchModal.searchBox.resetButtonTitle': 'Clear the query',
  'search.SearchModal.startScreen.favoriteSearchesTitle': 'Favorite',
  'search.SearchModal.startScreen.noRecentSearchesText': 'No recent searches',
  'search.SearchModal.startScreen.recentSearchesTitle': 'Recent',
  'search.SearchModal.startScreen.removeFavoriteSearchButtonTitle':
    'Remove this search from favorites',
  'search.SearchModal.startScreen.removeRecentSearchButtonTitle': 'Remove this search from history',
  'search.SearchModal.startScreen.saveRecentSearchButtonTitle': 'Save this search',
};
